import { apiBase } from './apiBase'
import { api, DOMAIN } from '../utils/api'

export const warehouseService = {
	// Lấy thông tin tồn kho
	getStock: async ({ storeId }) => {
		return await apiBase.get(`${api.GET_FRESH_STOCK}/${storeId}`)
	},

	// Lấy lịch sử theo category
	getHistory: async ({ storeId, date, month, year }) => {
		return await apiBase.get(`${api.GET_FRESH_HISTORY}/${storeId}?shift=true&date=${date}&month=${month}&year=${year}`)
	},

	// Lấy yêu cầu xuất/nhập kho
	getRequests: async ({ storeId }) => {
		return await apiBase.get(`${api.GET_REQUESTS}/${storeId}`)
	},

	// Kiểm tra tồn kho sống (Nem)
	checkFreshStock: (storeId) => apiBase.get(`${DOMAIN}/sub-stock/check-fresh-stock/${storeId}`),

	// Kiểm tra tồn kho chín (Nem)
	checkProductStock: (storeId) => apiBase.get(`${DOMAIN}/sub-stock/check-product-stock/${storeId}`),

	// Lấy tất cả lịch sử kho chín
	getAllHistory: (storeId) => apiBase.get(`${DOMAIN}/sub-stock/all-history/${storeId}`),

	// Nhập kho
	importStock: async (data) => {
		return apiBase.post(api.IMPORT_STOCK, data)
	},

	// Lấy danh sách stores
	getStores: async () => {
		return await apiBase.get(api.GET_ALL_STORE)
	},

	getSubStock: async ({ storeId }) => {
		return await apiBase.get(`${api.GET_SUB_STOCK}/${storeId}`)
	},

	getProductStock: async ({ storeId }) => {
		return await apiBase.get(`${api.GET_PRODUCT_STOCK}/${storeId}`)
	},

	getHistoryByDate: async (storeId, firstTimePick, secondTimePick) => {
		return await apiBase.post(`${api.GET_HISTORY_BY_DATE}/${storeId}`, {
			firstTimePick,
			secondTimePick,
		})
	},
}
